// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import { ArrowLeft, Expand, LoaderCircle, ChevronDown, ChevronUp } from 'lucide-react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import PropTypes from 'prop-types';
// import { useGlobalState } from '../../utils/GlobalState';

// const ImageWithLoader = ({ src, alt, onClick }) => {
//   const [loading, setLoading] = useState(true);

//   return (
//     <div
//       className="relative rounded-lg overflow-hidden shadow-lg h-48 w-full cursor-pointer bg-gray-800"
//       onClick={onClick}
//     >
//       {loading && (
//         <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
//           <LoaderCircle className="animate-spin w-8 h-8 text-gray-400" />
//         </div>
//       )}
//       <img
//         src={src}
//         alt={alt}
//         className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${
//           loading ? 'opacity-0' : 'opacity-100'
//         }`}
//         onLoad={() => setLoading(false)}
//       />
//       {!loading && (
//         <Expand
//           className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 text-white opacity-80 hover:opacity-100 transition"
//           strokeWidth={1.5}
//         />
//       )}
//     </div>
//   );
// };

// // FilterDropdown remains unchanged
// const FilterDropdown = ({ label, value, options, name, onChange, disabled = false }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   const handleOptionClick = (optionValue) => {
//     onChange({ target: { name, value: optionValue } });
//     setIsOpen(false);
//   };

//   return (
//     <div className="mb-4 relative" ref={dropdownRef}>
//       <div className="text-sm text-gray-400 mb-1">{label}</div>
//       <div
//         className={`relative cursor-pointer bg-gray-800 border border-gray-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-blue-500 w-64 ${
//           disabled ? 'opacity-50 cursor-not-allowed' : ''
//         }`}
//         onClick={() => !disabled && setIsOpen(!isOpen)}
//       >
//         {value || `Select ${name.replace(/([A-Z])/g, ' $1').trim()}`}
//         <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex flex-col items-center">
//           <ChevronUp className="text-gray-400 w-4 h-4 pointer-events-none" />
//           <ChevronDown className="text-gray-400 w-4 h-4 pointer-events-none" />
//         </div>
//       </div>
//       {isOpen && (
//         <div className="absolute top-full left-0 mt-1 bg-gray-800 rounded-lg w-full border border-blue-500 z-50">
//           <div className="p-0 max-h-60 overflow-y-auto">
//             {options.length > 0 ? (
//               options.map((option) => (
//                 <div
//                   key={option}
//                   className="px-4 py-2 hover:bg-gray-700 cursor-pointer border-b border-gray-600 last:border-b-0"
//                   onClick={() => handleOptionClick(option)}
//                 >
//                   <span className="text-white text-sm">{option}</span>
//                 </div>
//               ))
//             ) : (
//               <div className="px-4 py-2 text-gray-400 text-sm">
//                 No options available
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const DefectPhotos = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { state, updateState } = useGlobalState();

//   const {
//     defectType = 'Unknown',
//     filters = {},
//     chartData = [],
//     sizeOptions = ['All'],
//     odmOptions = ['All'],
//     brandOptions = ['All'],
//   } = location.state || {};

//   const safeFilters = {
//     productType: filters.productType || 'All',
//     size: filters.size || '',
//     odm: filters.odm || '',
//     brand: filters.brand || '',
//     datePeriod: filters.datePeriod || '',
//     customDateFrom: filters.customDateFrom || '',
//     customDateTo: filters.customDateTo || '',
//   };

//   const areAllFiltersAll = (
//     safeFilters.productType === 'All' &&
//     (safeFilters.size === 'All' || safeFilters.size === '') &&
//     (safeFilters.odm === 'All' || safeFilters.odm === '') &&
//     (safeFilters.brand === 'All' || safeFilters.brand === '')
//   );

//   const [additionalFilters, setAdditionalFilters] = useState({
//     issueRootCause: '',
//     rootCauseDetail: '',
//     dataFrom: 'All',
//   });

//   const issueRootCauseOptions = [
//     "OC Issue",
//     "LB Issue",
//     "Film Issue",
//     "Diffuser Plate",
//     "Reflect Sheet",
//     "Back Cover",
//     "Front Cover",
//     "Middle Cover",
//     "Deco",
//     "Spacer",
//     "Others",
//   ];

//   const rootCauseDetailOptions = {
//     "OC Issue": [
//       "Polarizer Material (Hygroscopic Stress)",
//       "OC defect",
//       "OC gum unevenness",
//       "Polarizer Gall",
//       "OC COF Damage (Scratching)",
//       "OC COF Damage (assembling)",
//       "OC Broken (Gap Issue)",
//     ],
//     "LB Issue": [
//       "Led too close to reflect sheet",
//       "LB Warping",
//       "LB LED Damage",
//       "Lens Light shape poor",
//       "LB Cable or Connector poor contact",
//       "LED too close to the four sides",
//       "Y Pitch too far",
//       "LED far away from corner",
//       "X Pitch too far",
//     ],
//     "Film Issue": [
//       "Film gall (hardness related)",
//       "Film space not enough",
//       "Film edge or film hook tripping",
//       "Film hygroscopic deformation",
//       "Film is pressed too tight",
//       "Film Issue (haze related)",
//     ],
//     "Diffuser Plate": [
//       "DP issue (haze related)",
//       "DP gall (hardness related)",
//       "DP is gored by support pin",
//     ],
//     "Reflect Sheet": [
//       "Reflect sheet punching or printing issue",
//       "Reflect sheet wrapping",
//       "Reflect sheet roulette or folding angle issue",
//       "Reflect sheet size NG",
//       "Reflect sheet collapsing",
//     ],
//     "Back Cover": [
//       "Back cover flatness poor",
//       "Back cover deformation",
//       "Back cover size NG",
//     ],
//     "Front Cover": ["Front cover deformation"],
//     "Middle Cover": ["Middle Cover deformation"],
//     "Deco": ["Deco deformation"],
//     "Spacer": ["Spacer hardness issue"],
//     "Others": ["User input"],
//   };

//   const dataFromOptions = [
//     'All',
//     'Labeling',
//     'Detection: Agreed',
//     'Detection: Disagreed',
//   ];

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;

//     setAdditionalFilters(prev => {
//       if (name === 'issueRootCause') {
//         return {
//           ...prev,
//           [name]: value,
//           rootCauseDetail: ''
//         };
//       }
//       return {
//         ...prev,
//         [name]: value
//       };
//     });
//   };

//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const imagesPerPage = 6;

//   useEffect(() => {
//     if (!safeFilters || !defectType) {
//       updateState({ error: 'No filters or defect type provided' });
//       setLoading(false);
//       return;
//     }

//     if (chartData && chartData.length > 0) { 
//      const apiDefectType = defectType.toLowerCase().replace(/\s+/g, '_');
//       const relevantItems = chartData.filter((item) =>
//         item?.MuraRecording?.muraLabeling?.defects?.some(
//           (defect) => defect.muraType === apiDefectType
//         )
//       );
//       updateState({
//         defectData: relevantItems,
//         imageCount: relevantItems.length,
//         error: null,
//       });
//       setLoading(false);
//     } else {
//       updateState({
//         defectData: [],
//         imageCount: 0,
//         error: 'No data available. Please go back and try again.',
//       });
//       setLoading(false);
//     }
//   }, []);

//   const filteredImages = useMemo(() => {
//     if (!state.defectData) {
//       return [];
//     }
//     const apiDefectType = defectType.toLowerCase().replace(/\s+/g, '_');
//     const defectTypeFiltered = state.defectData.filter(item => {
//       const defects = item?.MuraRecording?.muraLabeling?.defects || [];
//       return defects.some(defect => defect.muraType === apiDefectType);
//     });

//     if (!additionalFilters.issueRootCause || !additionalFilters.rootCauseDetail) {
//       return defectTypeFiltered;
//     }

//     const result = defectTypeFiltered.filter(item => {
//       const defects = item?.MuraRecording?.muraLabeling?.defects || [];

//       return defects.some(defect => {
//         const matchesDefectType = defect.muraType === apiDefectType;
//         if (!matchesDefectType) return false;

//         if (!defect.muraLabelIssue) {
//           return false;
//         }

//         const matchesRootCause = defect.muraLabelIssue.muraRootCause ===
//           additionalFilters.issueRootCause.toLowerCase().replace(/\s+/g, '_');

//         const matchesRootCauseDetail = defect.muraLabelIssue.muraRootIssue &&
//           defect.muraLabelIssue.muraRootIssue.some(issue =>
//             issue === additionalFilters.rootCauseDetail.toLowerCase().replace(/\s+/g, '_')
//           );

//         return matchesRootCause && matchesRootCauseDetail;
//       });
//     });
//     return result;
//   }, [state.defectData, defectType, additionalFilters]);

//   const filteredImageCount = filteredImages.length;

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [additionalFilters]);

//   const handleBackClick = () => {
//     navigate('/statistics-analysis', {
//       state: {
//         filters: safeFilters,
//         chartData,
//         sizeOptions,
//         odmOptions,
//         brandOptions,
//       },
//     });
//   };

//   const handleImageClick = (id) => {
//     navigate('/photo-review', {
//       state: {
//         cardId: id,
//         defectType,
//         filters: safeFilters,
//         chartData,
//         sizeOptions,
//         odmOptions,
//         brandOptions,
//         images: filteredImages,
//         imageCount: filteredImageCount,
//         additionalFilters,
//       },
//     });
//   };

//   const indexOfLastImage = currentPage * imagesPerPage;
//   const indexOfFirstImage = indexOfLastImage - imagesPerPage;
//   const currentImages = filteredImages.slice(indexOfFirstImage, indexOfLastImage);
//   const totalPages = Math.ceil(filteredImageCount / imagesPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   return (
//     <div className="min-h-screen bg-black text-white p-6">
//       <div className="mb-6">
//         <div className="flex items-center mb-5">
//           <ArrowLeft
//             className="w-7 h-7 mr-3 text-white cursor-pointer"
//             onClick={handleBackClick}
//           />
//           <h1 className="text-sm text-gray-300">
//             Defect Types / {areAllFiltersAll ? defectType : `${safeFilters.productType} ${safeFilters.size} ${safeFilters.odm} ${safeFilters.brand}`}
//           </h1>
//         </div>
//         <h2 className="text-xl font-semibold">
//           {defectType} Photos ({filteredImageCount} {filteredImageCount === 1 ? 'Image' : 'Images'})
//         </h2>
//         <p className="text-gray-400 text-sm">
//           View photos of {defectType} defects for selected filters.
//         </p>
//       </div>

//       <div className="mb-6">
//         <h3 className="text-lg font-medium mb-2">Filter</h3>
//         <div className="space-y-4">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
//             <span className="text-md text-white font-bold w-full sm:w-40">
//               Issue Root Cause
//             </span>
//             <FilterDropdown
//               label=""
//               value={additionalFilters.issueRootCause}
//               options={issueRootCauseOptions}
//               name="issueRootCause"
//               onChange={handleFilterChange}
//             />
//           </div>

//           <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
//             <span className="text-md text-white font-bold w-full sm:w-40">
//               Root Cause Detail
//             </span>
//             <FilterDropdown
//               label=""
//               value={additionalFilters.rootCauseDetail}
//               options={additionalFilters.issueRootCause ? rootCauseDetailOptions[additionalFilters.issueRootCause] || [] : []}
//               name="rootCauseDetail"
//               onChange={handleFilterChange}
//             />
//           </div>
//         </div>
//       </div>

//       {loading ? (
//         <div className="text-gray-400 text-center py-4">Loading...</div>
//       ) : state.error ? (
//         <div className="text-red-400 text-center py-4">{state.error}</div>
//       ) : filteredImageCount === 0 ? (
//         <div className="text-gray-400 text-center py-4">
//           {additionalFilters.issueRootCause && additionalFilters.rootCauseDetail
//             ? `No images available for ${defectType} with the selected root cause filters`
//             : `No images available for ${defectType} with the selected filters`
//           }
//         </div>
//       ) : (
//         <>
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//             {currentImages.map((item, index) => (
//               <div key={item._id} className="flex flex-col items-center relative">
//                 <ImageWithLoader
//                   src={item.MuraRecording.rawImageUrl}
//                   alt={item.productInfo?.modelName || `Product ${indexOfFirstImage + index + 1}`}
//                   onClick={() => handleImageClick(item._id)}
//                 />
//                 <span className="mt-2 text-white font-semibold">
//                   Product Name = {item.productInfo?.modelName || `Product ${indexOfFirstImage + index + 1}`}
//                 </span>
//               </div>
//             ))}
//           </div>

//           {totalPages > 1 && (
//             <div className="mt-6 flex justify-center items-center space-x-2 text-gray-400">
//               <button
//                 onClick={() => paginate(Math.max(1, currentPage - 1))}
//                 disabled={currentPage === 1}
//                 className="disabled:opacity-50"
//               >
//                 &lt;
//               </button>

//               {Array.from({ length: totalPages }, (_, i) => i + 1)
//                 .slice(
//                   Math.floor((currentPage - 1) / 5) * 5,
//                   Math.floor((currentPage - 1) / 5) * 5 + 5
//                 )
//                 .map((number) => (
//                   <button
//                     key={number}
//                     onClick={() => paginate(number)}
//                     className={`${currentPage === number ? 'text-white font-bold' : ''}`}
//                   >
//                     {number}
//                   </button>
//                 ))}

//               <button
//                 onClick={() => paginate(Math.min(totalPages, currentPage + 1))}
//                 disabled={currentPage === totalPages}
//                 className="disabled:opacity-50"
//               >
//                 &gt;
//               </button>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// DefectPhotos.propTypes = {
//   location: PropTypes.shape({
//     state: PropTypes.shape({
//       defectType: PropTypes.string,
//       filters: PropTypes.shape({
//         productType: PropTypes.string,
//         size: PropTypes.string,
//         odm: PropTypes.string,
//         brand: PropTypes.string,
//         datePeriod: PropTypes.string,
//         customDateFrom: PropTypes.string,
//         customDateTo: PropTypes.string,
//       }),
//       chartData: PropTypes.array,
//       sizeOptions: PropTypes.arrayOf(PropTypes.string),
//       odmOptions: PropTypes.arrayOf(PropTypes.string),
//       brandOptions: PropTypes.arrayOf(PropTypes.string),
//     }),
//   }),
// };

// export default DefectPhotos ;
  

// -------------
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { ArrowLeft, Expand, LoaderCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useGlobalState } from '../../utils/GlobalState';

// ImageWithLoader remains unchanged
const ImageWithLoader = ({ src, alt, onClick }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div
      className="relative rounded-lg overflow-hidden shadow-lg h-48 w-full cursor-pointer bg-gray-800"
      onClick={onClick}
    >
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
          <LoaderCircle className="animate-spin w-8 h-8 text-gray-400" />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${
          loading ? 'opacity-0' : 'opacity-100'
        }`}
        onLoad={() => setLoading(false)}
      />
      {!loading && (
        <Expand
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 text-white opacity-80 hover:opacity-100 transition"
          strokeWidth={1.5}
        />
      )}
    </div>
  );
};

const FilterDropdown = ({ label, value, options, name, onChange, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (optionValue) => {
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
  };

  return (
    <div className="mb-4 relative" ref={dropdownRef}>
      <div className="text-sm text-gray-400 mb-1">{label}</div>
      <div
        className={`relative cursor-pointer bg-gray-800 border border-gray-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-blue-500 w-64 ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        {value || `Select ${name.replace(/([A-Z])/g, ' $1').trim()}`}
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex flex-col items-center">
          <ChevronUp className="text-gray-400 w-4 h-4 pointer-events-none" />
          <ChevronDown className="text-gray-400 w-4 h-4 pointer-events-none" />
        </div>
      </div>
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 bg-gray-800 rounded-lg w-full border border-blue-500 z-50">
          <div className="p-0 max-h-60 overflow-y-auto">
            {options.length > 0 ? (
              options.map((option) => (
                <div
                  key={option}
                  className="px-4 py-2 hover:bg-gray-700 cursor-pointer border-b border-gray-600 last:border-b-0"
                  onClick={() => handleOptionClick(option)}
                >
                  <span className="text-white text-sm">{option}</span>
                </div>
              ))
            ) : (
              <div className="px-4 py-2 text-gray-400 text-sm">
                No options available
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const DefectPhotos = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, updateState } = useGlobalState();

  // Log the entire location state to see what's available
  console.log('Location state:', location.state);

  const {
    defectType = 'Unknown',
    filters = {},
    chartData = [],
    sizeOptions = ['All'],
    odmOptions = ['All'],
    brandOptions = ['All'],
  } = location.state || {};

  // Log the extracted values
  console.log('Defect type:', defectType);
  console.log('Filters:', filters);
  console.log('Chart data length:', chartData.length);

  const safeFilters = {
    productType: filters.productType || 'All',
    size: filters.size || '',
    odm: filters.odm || '',
    brand: filters.brand || '',
    datePeriod: filters.datePeriod || '',
    customDateFrom: filters.customDateFrom || '',
    customDateTo: filters.customDateTo || '',
  };

  // Determine if all filters are set to 'All' or empty
  const areAllFiltersAll = (
    safeFilters.productType === 'All' &&
    (safeFilters.size === 'All' || safeFilters.size === '') &&
    (safeFilters.odm === 'All' || safeFilters.odm === '') &&
    (safeFilters.brand === 'All' || safeFilters.brand === '')
  );

  const [additionalFilters, setAdditionalFilters] = useState({
    issueRootCause: '',
    rootCauseDetail: '',
    dataFrom: 'All',
  });

  const issueRootCauseOptions = [
    "OC Issue",
    "LB Issue",
    "Film Issue",
    "Diffuser Plate",
    "Reflect Sheet",
    "Back Cover",
    "Front Cover",
    "Middle Cover",
    "Deco",
    "Spacer",
    "Others",
  ];

  const rootCauseDetailOptions = {
    "OC Issue": [
      "Polarizer Material (Hygroscopic Stress)",
      "OC defect",
      "OC gum unevenness",
      "Polarizer Gall",
      "OC COF Damage (Scratching)",
      "OC COF Damage (assembling)",
      "OC Broken (Gap Issue)",
    ],
    "LB Issue": [
      "Led too close to reflect sheet",
      "LB Warping",
      "LB LED Damage",
      "Lens Light shape poor",
      "LB Cable or Connector poor contact",
      "LED too close to the four sides",
      "Y Pitch too far",
      "LED far away from corner",
      "X Pitch too far",
    ],
    "Film Issue": [
      "Film gall (hardness related)",
      "Film space not enough",
      "Film edge or film hook tripping",
      "Film hygroscopic deformation",
      "Film is pressed too tight",
      "Film Issue (haze related)",
    ],
    "Diffuser Plate": [
      "DP issue (haze related)",
      "DP gall (hardness related)",
      "DP is gored by support pin",
    ],
    "Reflect Sheet": [
      "Reflect sheet punching or printing issue",
      "Reflect sheet wrapping",
      "Reflect sheet roulette or folding angle issue",
      "Reflect sheet size NG",
      "Reflect sheet collapsing",
    ],
    "Back Cover": [
      "Back cover flatness poor",
      "Back cover deformation",
      "Back cover size NG",
    ],
    "Front Cover": ["Front cover deformation"],
    "Middle Cover": ["Middle Cover deformation"],
    "Deco": ["Deco deformation"],
    "Spacer": ["Spacer hardness issue"],
    "Others": ["User input"],
  };

  const dataFromOptions = [
    'All',
    'Labeling',
    'Detection: Agreed',
    'Detection: Disagreed',
  ];

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setAdditionalFilters(prev => {
      if (name === 'issueRootCause') {
        return {
          ...prev,
          [name]: value,
          rootCauseDetail: ''
        };
      }
      return {
        ...prev,
        [name]: value
      };
    });
  };

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const imagesPerPage = 6;

  useEffect(() => {
    if (!safeFilters || !defectType) {
      updateState({ error: 'No filters or defect type provided' });
      setLoading(false);
      return;
    }

    if (chartData && chartData.length > 0) {
      console.log('Using chartData from location state:', chartData);

      const apiDefectType = defectType.toLowerCase().replace(/\s+/g, '_');
      console.log('Looking for defect type:', apiDefectType);

      const relevantItems = chartData.filter((item) =>
        item?.MuraRecording?.muraLabeling?.defects?.some(
          (defect) => defect.muraType === apiDefectType
        )
      );

      console.log('Relevant items count:', relevantItems.length);
      console.log('Relevant items:', relevantItems);

      updateState({
        defectData: relevantItems,
        imageCount: relevantItems.length,
        error: null,
      });
      setLoading(false);
    } else {
      console.log('No chartData found');
      updateState({
        defectData: [],
        imageCount: 0,
        error: 'No data available. Please go back and try again.',
      });
      setLoading(false);
    }
  }, []);

  const filteredImages = useMemo(() => {
    if (!state.defectData) {
      console.log('No defect data available for filtering');
      return [];
    }

    console.log('Filtering defect data with additional filters:', additionalFilters);

    const apiDefectType = defectType.toLowerCase().replace(/\s+/g, '_');

    const defectTypeFiltered = state.defectData.filter(item => {
      const defects = item?.MuraRecording?.muraLabeling?.defects || [];
      return defects.some(defect => defect.muraType === apiDefectType);
    });

    console.log('Images after defect type filtering:', defectTypeFiltered.length);

    const result = defectTypeFiltered.filter(item => {
      const defects = item?.MuraRecording?.muraLabeling?.defects || [];

      return defects.some(defect => {
        const matchesDefectType = defect.muraType === apiDefectType;
        if (!matchesDefectType) return false;

        let matchesRootCause = true;
        if (additionalFilters.issueRootCause) {
          if (!defect.muraLabelIssue) {
            console.log('Defect has no muraLabelIssue data:', defect);
            return false;
          }
          const filterRootCause = additionalFilters.issueRootCause.toLowerCase().replace(/\s+/g, '_');
          matchesRootCause = defect.muraLabelIssue.muraRootCause === filterRootCause;
          console.log('Checking defect root cause:', {
            defectRootCause: defect.muraLabelIssue.muraRootCause,
            filterRootCause,
            matchesRootCause,
          });
        }

        let matchesRootCauseDetail = true;
        if (additionalFilters.rootCauseDetail) {
          if (!defect.muraLabelIssue) {
            console.log('Defect has no muraLabelIssue data:', defect);
            return false;
          }
          const filterRootDetail = additionalFilters.rootCauseDetail.toLowerCase().replace(/\s+/g, '_');
          matchesRootCauseDetail = defect.muraLabelIssue.muraRootIssue &&
            defect.muraLabelIssue.muraRootIssue.some(issue => issue === filterRootDetail);
          console.log('Checking defect root cause detail:', {
            defectRootIssue: defect.muraLabelIssue.muraRootIssue,
            filterRootDetail,
            matchesRootCauseDetail,
          });
        }

        return matchesRootCause && matchesRootCauseDetail;
      });
    });

    console.log('Filtered images count after root cause filtering:', result.length);
    return result;
  }, [state.defectData, defectType, additionalFilters]);

  const filteredImageCount = filteredImages.length;

  useEffect(() => {
    setCurrentPage(1);
  }, [additionalFilters]);

  const handleBackClick = () => {
    navigate('/statistics-analysis', {
      state: {
        filters: safeFilters,
        chartData,
        sizeOptions,
        odmOptions,
        brandOptions,
      },
    });
  };

  const handleImageClick = (id) => {
    navigate('/photo-review', {
      state: {
        cardId: id,
        defectType,
        filters: safeFilters,
        chartData,
        sizeOptions,
        odmOptions,
        brandOptions,
        images: filteredImages,
        imageCount: filteredImageCount,
        additionalFilters,
      },
    });
  };

  const indexOfLastImage = currentPage * imagesPerPage;
  const indexOfFirstImage = indexOfLastImage - imagesPerPage;
  const currentImages = filteredImages.slice(indexOfFirstImage, indexOfLastImage);
  const totalPages = Math.ceil(filteredImageCount / imagesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen bg-black text-white p-6">
      <div className="mb-6">
        <div className="flex items-center mb-5">
          <ArrowLeft
            className="w-7 h-7 mr-3 text-white cursor-pointer"
            onClick={handleBackClick}
          />
          <h1 className="text-sm text-gray-300">
            Defect Types / {areAllFiltersAll ? defectType : `${safeFilters.productType} ${safeFilters.size} ${safeFilters.odm} ${safeFilters.brand}`}
          </h1>
        </div>
        <h2 className="text-xl font-semibold">
          {defectType} Photos ({filteredImageCount} {filteredImageCount === 1 ? 'Image' : 'Images'})
        </h2>
        <p className="text-gray-400 text-sm">
          View photos of {defectType} defects for selected filters.
        </p>
      </div>

      <div className="mb-6">
        <h3 className="text-lg font-medium mb-2">Filter</h3>
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
            <span className="text-md text-white font-bold w-full sm:w-40">
              Issue Root Cause
            </span>
            <FilterDropdown
              label=""
              value={additionalFilters.issueRootCause}
              options={issueRootCauseOptions}
              name="issueRootCause"
              onChange={handleFilterChange}
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
            <span className="text-md text-white font-bold w-full sm:w-40">
              Root Cause Detail
            </span>
            <FilterDropdown
              label=""
              value={additionalFilters.rootCauseDetail}
              options={additionalFilters.issueRootCause ? rootCauseDetailOptions[additionalFilters.issueRootCause] || [] : []}
              name="rootCauseDetail"
              onChange={handleFilterChange}
            />
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-gray-400 text-center py-4">Loading...</div>
      ) : state.error ? (
        <div className="text-red-400 text-center py-4">{state.error}</div>
      ) : filteredImageCount === 0 ? (
        <div className="text-gray-400 text-center py-4">
          {additionalFilters.issueRootCause && additionalFilters.rootCauseDetail
            ? `No images available for ${defectType} with the selected root cause filters`
            : `No images available for ${defectType} with the selected filters`
          }
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {currentImages.map((item, index) => (
              <div key={item._id} className="flex flex-col items-center relative">
                <ImageWithLoader
                  src={item.MuraRecording.rawImageUrl}
                  alt={item.productInfo?.modelName || `Product ${indexOfFirstImage + index + 1}`}
                  onClick={() => handleImageClick(item._id)}
                />
                <span className="mt-2 text-white font-semibold">
                  Product Name = {item.productInfo?.modelName || `Product ${indexOfFirstImage + index + 1}`}
                </span>
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="mt-6 flex justify-center items-center space-x-2 text-gray-400">
              <button
                onClick={() => paginate(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                className="disabled:opacity-50"
              >
                &lt;
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .slice(
                  Math.floor((currentPage - 1) / 5) * 5,
                  Math.floor((currentPage - 1) / 5) * 5 + 5
                )
                .map((number) => (
                  <button
                    key={number}
                    onClick={() => paginate(number)}
                    className={`${currentPage === number ? 'text-white font-bold' : ''}`}
                  >
                    {number}
                  </button>
                ))}

              <button
                onClick={() => paginate(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
                className="disabled:opacity-50"
              >
                &gt;
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

DefectPhotos.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      defectType: PropTypes.string,
      filters: PropTypes.shape({
        productType: PropTypes.string,
        size: PropTypes.string,
        odm: PropTypes.string,
        brand: PropTypes.string,
        datePeriod: PropTypes.string,
        customDateFrom: PropTypes.string,
        customDateTo: PropTypes.string,
      }),
      chartData: PropTypes.array,
      sizeOptions: PropTypes.arrayOf(PropTypes.string),
      odmOptions: PropTypes.arrayOf(PropTypes.string),
      brandOptions: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
};

export default DefectPhotos ;